import axios from 'axios';
import logType from './vendorLogType';
import { logTypeExists } from '../../AuditLogs/utilities';
import { elasticRequest } from '../../../services/elasticService';

export const addVendorLog = async (
  url: string,
  action: string,
  description: string,
  username: string,
  comment: string,
  detailData?: any
) => {
  const typeExists = await logTypeExists(url, 'vendorlogs');
  if (!typeExists) {
    addVendorLogType(url);
  }
  const data = {
    action,
    description,
    username,
    created_date: new Date(),
    comment,
    detailData,
  };
  url = url + 'vendorlogs/default';
  try {
    elasticRequest(url, JSON.stringify(data))
      .then((result) => {
        //console.log('added log type?', JSON.stringify(result));
      })
      .catch(function (error) {
        console.log(error);
      });
  } catch (ex) {
    console.log(ex);
  }
};

export const addVendorLogType = (url: string) => {
  url = url + 'logtype/default';
  try {
    elasticRequest(url, JSON.stringify(logType))
      .then((result) => {
        //console.log('added log type?', JSON.stringify(result));
      })
      .catch(function (error) {
        console.log(error);
      });
  } catch (ex) {
    console.log(ex);
  }
};
